import { Button } from "@legal-500/legal500-design-system";
import type { MouseEvent } from "react";
import { Link } from "react-router-dom";
import styles from "./RunBanner.module.css";

function isPlainClick(event: MouseEvent<HTMLAnchorElement>): boolean {
  return event.button === 0 && !event.metaKey && !event.ctrlKey && !event.shiftKey && !event.altKey;
}

type RunBannerProps = {
  label: string;
  status: string;
  linkPath: string;
  linkLabel: string;
  onNavigate: (path: string) => void;
  onStop: () => void;
};

export function RunBanner({
  label,
  status,
  linkPath,
  linkLabel,
  onNavigate,
  onStop,
}: RunBannerProps) {
  function handleLinkClick(event: MouseEvent<HTMLAnchorElement>) {
    if (!isPlainClick(event)) return;
    event.preventDefault();
    onNavigate(linkPath);
  }

  return (
    <section className={styles.banner} aria-label={label}>
      <span role="status">{status}</span>
      <Link to={linkPath} className={styles.link} onClick={handleLinkClick}>
        {linkLabel}
      </Link>
      <Button variant="outlined" color="secondary" size="small" onClick={onStop}>
        Stop
      </Button>
    </section>
  );
}
